<template>
    <div class="mapbox" ref="mapBox"></div>
</template>

<script>

import mapboxgl from 'mapbox-gl';

export default {
    props: {
        token: { required: true },
        mapStyle: { required: true },
        coordinates: { default: [] },
        options: { default: {} }
    },
    mounted() {
        this.init();
    },
    methods: {
        setToken() {
            mapboxgl.accessToken = this.token;
        },
        createMarker() {
            let el    = document.createElement('div');
            let pin   = document.createElement('div');
            let pulse = document.createElement('div');
            pin.className = 'pin';
            pulse.className = 'pulse';
            el.className = 'marker bounce-a';
            el.appendChild(pin);
            el.appendChild(pulse);
            return el;
        },
        init() {
            this.setToken();

            let map = new mapboxgl.Map({
                container: this.$refs.mapBox,
                style: this.mapStyle,
                ...this.options
            });

            map.addControl(new mapboxgl.NavigationControl());

            this.coordinates.forEach(function(marker) {
                let el = this.createMarker();
                new mapboxgl.Marker(el, {offset: [0, -15]})
                    .setLngLat(marker)
                    .addTo(map);
            }, this);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/src/components/Map/MapboxMap.vue